// M05 百分法 - 主題 06-10 數據文件
// Percentage Method - Topics 06-10
// 系統化設計，準備後續 Supabase 數據遷移

// M05-06: 連續百分變化 (Continuous Percentage Changes)
export const M05_06_PROBLEMS = [
  {
    id: "M05_06_001",
    topicId: "M05_06",
    question: "基本連續百分變化：\n(a) 某數先增加20%，再增加25%，最終是原數的多少倍\n(b) 某數先減少30%，再減少40%，最終是原數的多少倍\n(c) 某數先增加50%，再減少20%，最終比原數變化多少",
    solution: "(a) 1.5倍, (b) 0.42倍, (c) 增加20%",
    explanation: "連續百分變化要逐步計算，最終結果是各步變化率的乘積。",
    hint: "連續變化：原數 × (1 ± 變化率₁) × (1 ± 變化率₂) = 最終結果。",
    difficulty: 2,
    order: 1,
    steps: [
      "(a) 最終 = 原數 × (1 + 20%) × (1 + 25%) = 原數 × 1.2 × 1.25 = 1.5 × 原數",
      "(b) 最終 = 原數 × (1 - 30%) × (1 - 40%) = 原數 × 0.7 × 0.6 = 0.42 × 原數",
      "(c) 最終 = 原數 × (1 + 50%) × (1 - 20%) = 原數 × 1.5 × 0.8 = 1.2 × 原數，增加20%"
    ]
  },
  {
    id: "M05_06_002",
    topicId: "M05_06",
    question: "三次連續變化：\n(a) 100連續三次各增加10%後是多少\n(b) 某數連續三次分別變化+20%、-15%、+30%後是156，求原數\n(c) 某投資連續三年收益率分別為8%、12%、-5%，三年總收益率是多少",
    solution: "(a) 133.1, (b) 100, (c) 15.976%",
    explanation: "多次連續變化要按順序逐步計算或建立方程。",
    hint: "三次變化：原數 × (1 ± r₁) × (1 ± r₂) × (1 ± r₃)。",
    difficulty: 3,
    order: 2,
    steps: [
      "(a) 100 × (1.1)³ = 100 × 1.331 = 133.1",
      "(b) 原數 = 156 ÷ (1.2 × 0.85 × 1.3) = 156 ÷ 1.326 = 117.6",
      "(c) 總收益率 = 1.08 × 1.12 × 0.95 - 1 = 1.15976 - 1 = 15.976%"
    ]
  },
  {
    id: "M05_06_003",
    topicId: "M05_06",
    question: "實際問題中的連續變化：\n(a) 某商品先漲價15%，再降價12%，最終售價比原價變化多少\n(b) 某公司員工先裁員20%，再招聘25%，最終員工比原來變化多少\n(c) 某股票第一天漲5%，第二天跌3%，第三天漲2%，三天總變化率是多少",
    solution: "(a) 增加1.2%, (b) 不變, (c) 增加3.954%",
    explanation: "實際問題中的連續變化要理解每次變化的基數。",
    hint: "每次變化的基數是上一次變化的結果。",
    difficulty: 2,
    order: 3,
    steps: [
      "(a) 最終 = 原價 × 1.15 × 0.88 = 1.012 × 原價，增加1.2%",
      "(b) 最終 = 原數 × 0.8 × 1.25 = 1.0 × 原數，不變",
      "(c) 最終 = 原價 × 1.05 × 0.97 × 1.02 = 1.03954 × 原價，增加3.954%"
    ]
  },
  {
    id: "M05_06_004",
    topicId: "M05_06",
    question: "連續變化的逆向問題：\n(a) 某數連續兩次各增加20%後是144，求原數\n(b) 某數先增加25%，再減少某個百分比後回到原數，求這個百分比\n(c) 某數連續三次變化後是原數的1.728倍，若每次變化率相同，求變化率",
    solution: "(a) 100, (b) 20%, (c) 20%",
    explanation: "逆向問題要從結果推導原因，建立逆向方程。",
    hint: "逆向思維：從最終結果除以各步變化率得到原數。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 原數 = 144 ÷ (1.2)² = 144 ÷ 1.44 = 100",
      "(b) 1.25 × (1 - x%) = 1，x% = 1 - 1/1.25 = 20%",
      "(c) (1 + r)³ = 1.728，1 + r = ∛1.728 = 1.2，r = 20%"
    ]
  },
  {
    id: "M05_06_005",
    topicId: "M05_06",
    question: "複合增長和衰減：\n(a) 某細菌每小時增長25%，6小時後數量是原來的多少倍\n(b) 某放射性物質每年衰減8%，10年後剩餘原量的百分之幾\n(c) 某投資前5年每年增長12%，後3年每年衰減5%，8年總變化率是多少",
    solution: "(a) 3.814倍, (b) 43.44%, (c) 增加59.02%",
    explanation: "複合增長遵循指數模型，要用指數運算。",
    hint: "指數模型：A = P(1 ± r)ⁿ。",
    difficulty: 3,
    order: 5,
    steps: [
      "(a) 倍數 = (1.25)⁶ = 3.814倍",
      "(b) 剩餘 = (0.92)¹⁰ = 0.4344 = 43.44%",
      "(c) 總變化 = (1.12)⁵ × (0.95)³ - 1 = 1.762 × 0.857 - 1 = 59.02%"
    ]
  },
  {
    id: "M05_06_006",
    topicId: "M05_06",
    question: "連續變化的綜合應用：\n(a) 甲乙兩數相等，甲連續兩次各增加15%，乙一次性增加30%，哪個最終更大\n(b) 某商品價格每月上漲5%，6個月後價格是原價的多少倍，需要一次性降價多少才能回到原價\n(c) 人口每年增長2%，GDP每年增長6%，多少年後人均GDP翻倍",
    solution: "(a) 甲更大(1.3225 > 1.3), (b) 1.34倍，需降價25.47%, (c) 約18年",
    explanation: "綜合問題要分析不同變化模式的差異和關係。",
    hint: "比較不同變化模式時，要計算最終結果進行對比。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 甲：(1.15)² = 1.3225，乙：1.3，甲更大",
      "(b) 6個月後：(1.05)⁶ = 1.34倍，降價率 = 1 - 1/1.34 = 25.47%",
      "(c) 人均GDP增長率 = 6% - 2% = 4%，翻倍時間 = ln(2)/ln(1.04) ≈ 18年"
    ]
  }
];

// M05-07: 利潤計算 (Profit Calculations)
export const M05_07_PROBLEMS = [
  {
    id: "M05_07_001",
    topicId: "M05_07",
    question: "基本利潤計算：\n(a) 某商品成本80元，售價100元，求利潤率\n(b) 某商品利潤率25%，成本120元，求售價\n(c) 某商品售價150元，利潤率20%，求成本",
    solution: "(a) 25%, (b) 150元, (c) 125元",
    explanation: "利潤率 = (售價 - 成本) ÷ 成本 × 100%。",
    hint: "利潤 = 售價 - 成本，利潤率以成本為基數。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 利潤率 = (100 - 80) ÷ 80 × 100% = 20 ÷ 80 × 100% = 25%",
      "(b) 售價 = 成本 × (1 + 利潤率) = 120 × (1 + 25%) = 150元",
      "(c) 成本 = 售價 ÷ (1 + 利潤率) = 150 ÷ (1 + 20%) = 125元"
    ]
  },
  {
    id: "M05_07_002",
    topicId: "M05_07",
    question: "毛利率與淨利率：\n(a) 某商品售價200元，成本120元，稅費20元，求毛利率和淨利率\n(b) 某商品毛利率40%，各種費用佔售價的15%，求淨利率\n(c) 某商品淨利率18%，成本100元，各種費用22元，求售價",
    solution: "(a) 毛利率40%，淨利率30%, (b) 淨利率25%, (c) 售價200元",
    explanation: "毛利率 = (售價 - 成本) ÷ 售價，淨利率 = (售價 - 成本 - 費用) ÷ 售價。",
    hint: "毛利率以售價為基數，淨利率考慮所有費用。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 毛利率 = (200 - 120) ÷ 200 = 40%，淨利率 = (200 - 120 - 20) ÷ 200 = 30%",
      "(b) 毛利率40%意味著成本佔60%，淨利率 = 40% - 15% = 25%",
      "(c) 設售價x，x - 100 - 22 = 0.18x，0.82x = 122，x = 148.78元"
    ]
  },
  {
    id: "M05_07_003",
    topicId: "M05_07",
    question: "成本加成定價法：\n(a) 某商品成本60元，要求利潤率50%，求售價\n(b) 某商品售價180元，採用成本加成40%定價，求成本\n(c) 某商品成本80元，市場售價120元，若要達到30%利潤率，成本應控制在多少",
    solution: "(a) 90元, (b) 約128.57元, (c) 約92.31元",
    explanation: "成本加成定價：售價 = 成本 × (1 + 加成率)。",
    hint: "加成率通常等於目標利潤率。",
    difficulty: 2,
    order: 3,
    steps: [
      "(a) 售價 = 60 × (1 + 50%) = 60 × 1.5 = 90元",
      "(b) 成本 = 180 ÷ (1 + 40%) = 180 ÷ 1.4 ≈ 128.57元",
      "(c) 成本 = 120 ÷ (1 + 30%) = 120 ÷ 1.3 ≈ 92.31元"
    ]
  },
  {
    id: "M05_07_004",
    topicId: "M05_07",
    question: "批發與零售利潤：\n(a) 某商品出廠價50元，批發商加價20%，零售商再加價25%，求最終售價\n(b) 某商品零售價100元，零售商利潤率25%，批發商利潤率15%，求出廠價\n(c) 三級銷售：出廠價40元，一級批發加價15%，二級批發加價12%，零售加價20%，求最終售價",
    solution: "(a) 75元, (b) 約69.57元, (c) 約61.57元",
    explanation: "多級加價要逐級計算，每級都以上一級價格為基數。",
    hint: "多級定價：每一級的加價都以前一級的價格為基數。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 批發價 = 50 × 1.2 = 60元，零售價 = 60 × 1.25 = 75元",
      "(b) 批發價 = 100 ÷ 1.25 = 80元，出廠價 = 80 ÷ 1.15 ≈ 69.57元",
      "(c) 一級價 = 40 × 1.15 = 46元，二級價 = 46 × 1.12 = 51.52元，零售價 = 51.52 × 1.2 = 61.82元"
    ]
  },
  {
    id: "M05_07_005",
    topicId: "M05_07",
    question: "盈虧平衡分析：\n(a) 某商品固定成本10000元，單位變動成本30元，售價50元，求盈虧平衡點銷量\n(b) 某商品月銷量1000件，單價80元，固定成本20000元，要實現利潤15000元，單位變動成本應控制在多少\n(c) 某商品成本結構：固定成本40%，變動成本60%，總成本12萬元，售價15萬元，求利潤率和盈虧平衡銷量比例",
    solution: "(a) 500件, (b) 45元, (c) 利潤率25%，需銷量80%",
    explanation: "盈虧平衡點：固定成本 ÷ (單價 - 單位變動成本) = 盈虧平衡銷量。",
    hint: "盈虧平衡時，總收入 = 固定成本 + 變動成本。",
    difficulty: 3,
    order: 5,
    steps: [
      "(a) 盈虧平衡銷量 = 10000 ÷ (50 - 30) = 10000 ÷ 20 = 500件",
      "(b) 總收入 = 80000元，總成本 = 20000 + 35000 = 55000元，單位變動成本 = (80000 - 20000 - 15000) ÷ 1000 = 45元",
      "(c) 利潤率 = (150000 - 120000) ÷ 120000 = 25%，盈虧平衡 = 48000 ÷ (150000 - 72000) = 80%"
    ]
  },
  {
    id: "M05_07_006",
    topicId: "M05_07",
    question: "動態利潤分析：\n(a) 某商品第一季度利潤率20%，第二季度成本上升10%但售價不變，求第二季度利潤率\n(b) 某商品原利潤率30%，現要求利潤率提高到40%，在成本不變情況下售價應提高多少\n(c) 兩種商品：A商品成本100元利潤率25%，B商品成本80元利潤率40%，若各銷售100件，總利潤率是多少",
    solution: "(a) 約9.09%, (b) 約7.69%, (c) 約31.82%",
    explanation: "動態分析要考慮成本、售價、銷量等因素的變化對利潤的影響。",
    hint: "利潤率變化要重新計算各項指標的關係。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 設原成本100，售價120，新成本110，新利潤率 = (120 - 110) ÷ 110 ≈ 9.09%",
      "(b) 設原成本100，原售價130，新售價 = 100 × 1.4 = 140，提高 (140 - 130) ÷ 130 ≈ 7.69%",
      "(c) A利潤 = 100 × 25 = 2500，B利潤 = 80 × 40 = 3200，總利潤率 = 5700 ÷ 18000 ≈ 31.67%"
    ]
  }
];

// M05-08: 多重折扣 (Multiple Discounts)
export const M05_08_PROBLEMS = [
  {
    id: "M05_08_001",
    topicId: "M05_08",
    question: "連續折扣計算：\n(a) 某商品原價1000元，先打8折，再打9折，最終售價是多少\n(b) 某商品連續打兩次7.5折，相當於一次性打幾折\n(c) 某商品原價500元，連續三次折扣後售價324元，若每次折扣相同，求折扣率",
    solution: "(a) 720元, (b) 5.625折, (c) 9折",
    explanation: "連續折扣要逐次計算，最終折扣是各次折扣的乘積。",
    hint: "連續折扣：原價 × 折扣₁ × 折扣₂ = 最終價格。",
    difficulty: 2,
    order: 1,
    steps: [
      "(a) 最終價格 = 1000 × 0.8 × 0.9 = 720元",
      "(b) 總折扣 = 0.75 × 0.75 = 0.5625 = 5.625折",
      "(c) 折扣³ = 324/500 = 0.648，折扣 = ∛0.648 = 0.9 = 9折"
    ]
  },
  {
    id: "M05_08_002",
    topicId: "M05_08",
    question: "不同類型折扣組合：\n(a) 某商品原價800元，會員打9折，再用滿500減100優惠券，最終付款多少\n(b) 某商品原價600元，先用200元優惠券，再打8.5折，最終價格是多少\n(c) 某商品原價1200元，打8折後滿800減150，最終優惠了多少元",
    solution: "(a) 620元, (b) 340元, (c) 優惠390元",
    explanation: "不同類型折扣要按照優惠政策的順序和條件執行。",
    hint: "注意優惠券使用條件和折扣順序。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 會員價 = 800 × 0.9 = 720元，滿500減100，最終 = 720 - 100 = 620元",
      "(b) 用券後 = 600 - 200 = 400元，再打8.5折 = 400 × 0.85 = 340元",
      "(c) 打8折 = 1200 × 0.8 = 960元，滿800減150 = 960 - 150 = 810元，優惠 = 1200 - 810 = 390元"
    ]
  },
  {
    id: "M05_08_003",
    topicId: "M05_08",
    question: "階梯式折扣：\n(a) 某商品：1件原價，2件9.5折，3件及以上9折，購買5件單價100元商品需付多少\n(b) 某商品階梯價格：1-10件每件50元，11-20件每件45元，21件以上每件40元，購買25件需付多少\n(c) 某服務費用：前100元不打折，101-500元部分打9折，500元以上部分打8折，總費用800元需付多少",
    solution: "(a) 450元, (b) 1150元, (c) 700元",
    explanation: "階梯式折扣要分段計算，不同數量或金額適用不同折扣。",
    hint: "階梯折扣按照相應的數量或金額區間分別計算。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 5件按9折計算：5 × 100 × 0.9 = 450元",
      "(b) 1-10件：10 × 50 = 500，11-20件：10 × 45 = 450，21-25件：5 × 40 = 200，總計1150元",
      "(c) 前100元：100，101-500元：400 × 0.9 = 360，500元以上：300 × 0.8 = 240，總計700元"
    ]
  },
  {
    id: "M05_08_004",
    topicId: "M05_08",
    question: "組合優惠策略：\n(a) 某店：買二送一，或者全場7.5折，購買3件單價200元商品，哪種更優惠\n(b) 某商品：滿1000減200，或者打7折，購買1500元商品，選擇哪種優惠\n(c) 某套餐：單點總價300元，套餐價250元，或者單點打8.5折，哪種最便宜",
    solution: "(a) 買二送一更優惠(400元 < 450元), (b) 滿減更優惠(1300元 < 1350元), (c) 套餐最便宜(250元)",
    explanation: "組合優惠要分別計算各種方案的最終價格，選擇最優方案。",
    hint: "比較不同優惠方案時，要計算實際支付金額。",
    difficulty: 2,
    order: 4,
    steps: [
      "(a) 買二送一：2 × 200 = 400元，7.5折：3 × 200 × 0.75 = 450元，買二送一更優惠",
      "(b) 滿1000減200：1500 - 200 = 1300元，7折：1500 × 0.7 = 1050元，7折更優惠",
      "(c) 套餐250元，8.5折：300 × 0.85 = 255元，套餐最便宜"
    ]
  },
  {
    id: "M05_08_005",
    topicId: "M05_08",
    question: "會員等級折扣：\n(a) 某店會員體系：普通會員9.5折，銀卡會員9折，金卡會員8.5折，購買2000元商品，各等級實際支付多少\n(b) 某會員升級：消費滿5000元升銀卡(9折)，滿10000元升金卡(8.5折)，原普通會員(9.5折)已消費8000元，再消費多少升金卡划算\n(c) 某商品原價1000元，會員價800元，非會員打8.2折，會員年費100元，一年至少購買多少次該商品辦會員划算",
    solution: "(a) 普通1900元，銀卡1800元，金卡1700元, (b) 再消費2000元, (c) 至少5次",
    explanation: "會員體系要考慮不同等級的優惠幅度和升級條件。",
    hint: "比較會員和非會員的總成本，包括會員費用。",
    difficulty: 3,
    order: 5,
    steps: [
      "(a) 普通：2000 × 0.95 = 1900元，銀卡：2000 × 0.9 = 1800元，金卡：2000 × 0.85 = 1700元",
      "(b) 升金卡需消費10000元，已消費8000元，還需2000元",
      "(c) 設購買x次，會員：100 + 800x，非會員：1000 × 0.82x = 820x，100 + 800x < 820x，x > 5"
    ]
  },
  {
    id: "M05_08_006",
    topicId: "M05_08",
    question: "複雜折扣組合分析：\n(a) 某商場：全場8折，VIP會員再享9.5折，滿1000再減100，購買VIP會員1200元商品最終付款多少\n(b) 某活動：前100名顧客9折，會員8.8折，兩個優惠可疊加，非會員前100名和會員非前100名，購買500元商品各付多少\n(c) 某商品：原價2000元，雙11打7折，用券再減200元，會員再享9.5折，VIP會員購買最終價格和優惠幅度是多少",
    solution: "(a) 812元, (b) 非會員前100名396元，會員非前100名440元, (c) 1130元，優惠43.5%",
    explanation: "複雜折扣要仔細分析各種優惠的疊加規則和計算順序。",
    hint: "注意折扣疊加的順序和條件限制。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 全場8折：1200 × 0.8 = 960元，VIP再9.5折：960 × 0.95 = 912元，滿1000減100：912 - 100 = 812元",
      "(b) 非會員前100名：500 × 0.9 = 450元，會員非前100名：500 × 0.88 = 440元",
      "(c) 7折：2000 × 0.7 = 1400元，減券：1400 - 200 = 1200元，會員9.5折：1200 × 0.95 = 1140元，優惠幅度：(2000 - 1140) ÷ 2000 = 43%"
    ]
  }
];

// M05-09: 標價策略分析 (Pricing Strategy Analysis)
export const M05_09_PROBLEMS = [
  {
    id: "M05_09_001",
    topicId: "M05_09",
    question: "心理定價策略：\n(a) 某商品成本40元，要求利潤率50%，按心理定價法(尾數為9)定價，求建議售價\n(b) 某商品定價99元和100元，心理感知差異約15%，若成本60元，哪種定價利潤率更高\n(c) 某商品原定價128元，改為129元後銷量下降5%，但利潤率提高，分析是否值得",
    solution: "(a) 建議59元或69元, (b) 99元利潤率65%更高, (c) 需要具體分析總利潤變化",
    explanation: "心理定價利用消費者的價格感知偏差，通常使用以9結尾的價格。",
    hint: "心理定價要平衡價格吸引力和利潤水平。",
    difficulty: 2,
    order: 1,
    steps: [
      "(a) 理論售價 = 40 × 1.5 = 60元，心理定價建議59元或69元",
      "(b) 99元利潤率 = (99 - 60) ÷ 60 = 65%，100元利潤率 = (100 - 60) ÷ 60 = 66.67%，但99元心理接受度更高",
      "(c) 需要比較：128元銷量 × (128 - 成本) vs 129元銷量×0.95 × (129 - 成本)"
    ]
  },
  {
    id: "M05_09_002",
    topicId: "M05_09",
    question: "競爭定價策略：\n(a) 市場同類商品價格80-120元，某商品成本60元，採用跟隨策略定價100元，求利潤率\n(b) 某商品成本70元，競爭對手售價110元，採用滲透定價策略低20%定價，求售價和利潤率\n(c) 某高端商品成本200元，競爭對手300元，採用撇脂定價高30%，分析定價合理性",
    solution: "(a) 利潤率66.67%, (b) 售價88元，利潤率25.71%, (c) 售價390元，利潤率95%，定價偏高",
    explanation: "競爭定價要考慮市場競爭環境和自身成本結構。",
    hint: "不同競爭策略有不同的風險和收益特點。",
    difficulty: 3,
    order: 2,
    steps: [
      "(a) 利潤率 = (100 - 60) ÷ 60 × 100% = 66.67%",
      "(b) 售價 = 110 × (1 - 20%) = 88元，利潤率 = (88 - 70) ÷ 70 = 25.71%",
      "(c) 售價 = 300 × (1 + 30%) = 390元，利潤率 = (390 - 200) ÷ 200 = 95%，定價可能過高"
    ]
  },
  {
    id: "M05_09_003",
    topicId: "M05_09",
    question: "價值定價策略：\n(a) 某軟件開發成本10萬元，為客戶節省成本50萬元，按價值定價法收費30%，求售價和利潤率\n(b) 某諮詢服務成本5000元，客戶獲得收益20萬元，按價值分成10%定價，分析合理性\n(c) 某專利產品成本100元，市場獨有技術價值1000元，按價值定價法定價，求建議價格區間",
    solution: "(a) 售價15萬元，利潤率1400%, (b) 售價2萬元，性價比很高, (c) 建議300-600元區間",
    explanation: "價值定價基於產品為客戶創造的價值而非成本。",
    hint: "價值定價要評估產品的實際價值貢獻。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 售價 = 50萬 × 30% = 15萬元，利潤率 = (15 - 1) ÷ 1 × 100% = 1400%",
      "(b) 售價 = 20萬 × 10% = 2萬元，投入產出比 = 2萬 ÷ 0.5萬 = 40:1，非常合理",
      "(c) 基於價值的30%-60%定價：300-600元區間較合理"
    ]
  },
  {
    id: "M05_09_004",
    topicId: "M05_09",
    question: "動態定價策略：\n(a) 某商品淡季成本80元定價100元，旺季需求增加50%，動態定價應調整到多少\n(b) 某服務平日成本200元定價250元，週末需求增加80%，週末定價多少能保持相同利潤率\n(c) 某電商商品：庫存高時9折促銷，庫存中等時原價，庫存低時加價10%，分析策略合理性",
    solution: "(a) 建議調整到120-130元, (b) 週末定價360元, (c) 策略合理，符合供需規律",
    explanation: "動態定價根據需求變化、庫存水平等因素調整價格。",
    hint: "動態定價要平衡收益最大化和客戶接受度。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 旺季可承受更高價格，建議提價20-30%至120-130元",
      "(b) 保持25%利潤率，週末定價 = 200 × (1 + 80%) × 1.25 = 450元，但可能過高，建議360元",
      "(c) 庫存管理定價符合供需規律，有助於優化庫存周轉"
    ]
  },
  {
    id: "M05_09_005",
    topicId: "M05_09",
    question: "套餐定價策略：\n(a) 三個單品：A商品50元，B商品30元，C商品20元，設計套餐定價，單品總價打8.5折\n(b) 某餐廳：主菜60元，配菜25元，飲料15元，套餐定價85元，分析套餐優惠幅度\n(c) 某軟件：基礎版100元，高級版200元，專業版300元，設計組合套餐策略",
    solution: "(a) 套餐價85元, (b) 優惠15元，優惠幅度15%, (c) 建議基礎+高級套餐240元，高級+專業套餐420元",
    explanation: "套餐定價通過組合銷售提高客單價和利潤。",
    hint: "套餐定價要有足夠吸引力同時保證合理利潤。",
    difficulty: 2,
    order: 5,
    steps: [
      "(a) 套餐價 = (50 + 30 + 20) × 0.85 = 85元",
      "(b) 優惠幅度 = (60 + 25 + 15 - 85) ÷ 100 × 100% = 15%",
      "(c) 基礎+高級：300 × 0.8 = 240元，高級+專業：500 × 0.84 = 420元"
    ]
  },
  {
    id: "M05_09_006",
    topicId: "M05_09",
    question: "綜合定價策略評估：\n(a) 某新產品：成本100元，市場調研顯示150元接受度80%，180元接受度50%，200元接受度30%，哪種定價最優\n(b) 某商品採用階段定價：上市期200元，成長期180元，成熟期150元，分析各階段的戰略意圖\n(c) 某平台服務：免費版、基礎版50元/月、高級版100元/月，用戶轉化率分別為100%、20%、5%，評估定價結構",
    solution: "(a) 需要計算期望收益，180元可能最優, (b) 撇脂-滲透-競爭定價組合策略, (c) 免費版引流，付費版盈利的標準模式",
    explanation: "綜合定價策略要考慮多個因素和不同階段的目標。",
    hint: "最優定價要平衡銷量、利潤和市場策略目標。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 期望收益：150×0.8=120，180×0.5=90，200×0.3=60，150元定價最優",
      "(b) 上市期撇脂定價回收成本，成長期平衡定價擴大市場，成熟期競爭定價保持份額",
      "(c) 典型的免費增值模式，免費版獲客，付費版變現，轉化率符合行業標準"
    ]
  }
];

// M05-10: 單利公式 (Simple Interest Formula)
export const M05_10_PROBLEMS = [
  {
    id: "M05_10_001",
    topicId: "M05_10",
    question: "基本單利計算：\n(a) 本金5000元，年利率6%，存款2年，求利息和本息合計\n(b) 某筆投資3年後本息合計13600元，年利率8%，求本金\n(c) 本金8000元，3年後本息合計9440元，求年利率",
    solution: "(a) 利息600元，本息5600元, (b) 本金10000元, (c) 年利率6%",
    explanation: "單利公式：利息 = 本金 × 年利率 × 時間，本息合計 = 本金 + 利息。",
    hint: "單利計算中，利息只根據本金計算，不計複利。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 利息 = 5000 × 6% × 2 = 600元，本息 = 5000 + 600 = 5600元",
      "(b) 利息 = 13600 - 本金，本金 × 8% × 3 = 利息，本金 × (1 + 0.24) = 13600，本金 = 10000元",
      "(c) 利息 = 9440 - 8000 = 1440元，年利率 = 1440 ÷ (8000 × 3) = 6%"
    ]
  },
  {
    id: "M05_10_002",
    topicId: "M05_10",
    question: "不同時間單位的單利：\n(a) 本金12000元，月利率0.8%，存款8個月，求利息\n(b) 本金15000元，日利率0.05%，存款90天，求本息合計\n(c) 本金20000元，年利率7.2%，存款150天，求利息（按360天計算）",
    solution: "(a) 768元, (b) 15675元, (c) 600元",
    explanation: "單利計算要注意時間單位的統一：年利率配年數，月利率配月數，日利率配天數。",
    hint: "時間單位要與利率單位保持一致。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 利息 = 12000 × 0.8% × 8 = 768元",
      "(b) 利息 = 15000 × 0.05% × 90 = 675元，本息 = 15000 + 675 = 15675元",
      "(c) 利息 = 20000 × 7.2% × (150 ÷ 360) = 20000 × 7.2% × 5/12 = 600元"
    ]
  },
  {
    id: "M05_10_003",
    topicId: "M05_10",
    question: "單利實際應用：\n(a) 某人向銀行借款50000元，年利率5.5%，借期18個月，需還多少錢\n(b) 某企業短期融資100000元，月利率1.2%，3個月後歸還，計算融資成本\n(c) 某債券面值10000元，年利率4.8%，持有2.5年，到期收益多少",
    solution: "(a) 54125元, (b) 3600元, (c) 1200元",
    explanation: "實際應用中要注意利率類型、計息方式和時間計算。",
    hint: "借款利息是成本，投資利息是收益。",
    difficulty: 2,
    order: 3,
    steps: [
      "(a) 利息 = 50000 × 5.5% × 1.5 = 4125元，還款 = 50000 + 4125 = 54125元",
      "(b) 融資成本 = 100000 × 1.2% × 3 = 3600元",
      "(c) 收益 = 10000 × 4.8% × 2.5 = 1200元"
    ]
  },
  {
    id: "M05_10_004",
    topicId: "M05_10",
    question: "單利比較分析：\n(a) 方案A：年利率6%存3年；方案B：年利率5.5%存3.5年，本金相同，哪個收益更高\n(b) 甲銀行：年利率4.2%；乙銀行：月利率0.36%，存款1年，哪個更划算\n(c) 某投資：第一年利率5%，第二年利率6%，第三年利率7%，平均年利率是多少",
    solution: "(a) 方案B收益更高(19.25% > 18%), (b) 乙銀行更划算(4.32% > 4.2%), (c) 平均年利率6%",
    explanation: "比較不同利率方案要統一時間基準計算實際收益率。",
    hint: "比較時要換算成相同的時間基準。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 方案A收益率 = 6% × 3 = 18%，方案B收益率 = 5.5% × 3.5 = 19.25%，B更高",
      "(b) 甲銀行年收益率 = 4.2%，乙銀行年收益率 = 0.36% × 12 = 4.32%，乙更高",
      "(c) 總收益率 = 5% + 6% + 7% = 18%，平均年利率 = 18% ÷ 3 = 6%"
    ]
  },
  {
    id: "M05_10_005",
    topicId: "M05_10",
    question: "單利的逆向計算：\n(a) 某筆投資2年後獲得利息1800元，年利率6%，求本金\n(b) 本金25000元，3年後本息合計31000元，求年利率\n(c) 本金40000元，年利率5.4%，多長時間利息達到8640元",
    solution: "(a) 15000元, (b) 8%, (c) 4年",
    explanation: "逆向計算要根據已知條件反推未知量。",
    hint: "利用單利公式的變形：本金 = 利息 ÷ (利率 × 時間)。",
    difficulty: 2,
    order: 5,
    steps: [
      "(a) 本金 = 1800 ÷ (6% × 2) = 1800 ÷ 0.12 = 15000元",
      "(b) 利息 = 31000 - 25000 = 6000元，年利率 = 6000 ÷ (25000 × 3) = 8%",
      "(c) 時間 = 8640 ÷ (40000 × 5.4%) = 8640 ÷ 2160 = 4年"
    ]
  },
  {
    id: "M05_10_006",
    topicId: "M05_10",
    question: "單利綜合應用：\n(a) 某人分別向兩家銀行借款：甲行30000元年利率5%，乙行20000元年利率6%，2年後總還款多少\n(b) 某企業資金需求：前6個月需要100000元，後6個月再增加50000元，年利率8%，總利息成本多少\n(c) 某投資組合：60%資金投資年利率5%項目，40%資金投資年利率7%項目，組合平均收益率多少",
    solution: "(a) 57400元, (b) 10000元, (c) 5.8%",
    explanation: "綜合應用要分別計算各部分，然後匯總。",
    hint: "複雜問題要分解成簡單的單利計算。",
    difficulty: 3,
    order: 6,
    steps: [
      "(a) 甲行還款 = 30000 × (1 + 5% × 2) = 33000元，乙行還款 = 20000 × (1 + 6% × 2) = 22400元，總計55400元",
      "(b) 前6個月利息 = 100000 × 8% × 0.5 = 4000元，後6個月利息 = 150000 × 8% × 0.5 = 6000元，總計10000元",
      "(c) 組合收益率 = 60% × 5% + 40% × 7% = 3% + 2.8% = 5.8%"
    ]
  }
]; 